import gql from "graphql-tag";
import { IMember } from "@/models/Member.model";

export const allMembers = () => {
  return gql`
    query allMembers($conference: ID!) {
      allMembers(conference: $conference) {
        _id
        conference
        firstName
        lastName
        country
        email
        title
        gender
        university
        link
        biography
        role
        hasSubmitted
        isInternationalCommittee
        isLocalCommittee
        isScientificCommittee
        isFullRegistered
        isReviewer
        isAdmin
        isInvitedSpeaker
        isChairman
        isCoChairman
        isHonoraryChairman
        isScientificCommitteeChairman
        isMainOrganizer
        hasEditConferences
        hasEditContent
        hasEditMembers
        hasEditArticles
        hasEditAdmins
      }
    }
  `;
};

export const allCommitteeMembers = () => {
  return gql`
    query allCommitteeMembers($conference: ID!) {
      allCommitteeMembers(conference: $conference) {
        _id
        firstName
        lastName
        country
        title
        gender
        university
        link
        biography
        isInternationalCommittee
        isLocalCommittee
        isScientificCommittee
        isChairman
        isCoChairman
        isHonoraryChairman
        isScientificCommitteeChairman
        isMainOrganizer
      }
    }
  `;
};
export const invitedSpeakers = () => {
  return gql`
    query invitedSpeakers($conference: ID!) {
      invitedSpeakers(conference: $conference) {
        _id
        firstName
        lastName
        country
        title
        gender
        university
        link
        biography
        isInvitedSpeaker
      }
    }
  `;
};

export const updateMember = (member: IMember) => {
  return gql`mutation {updateMember(_id:"${member._id}",
  conference:"${member.conference}",
    firstName:"${member.firstName}",
  lastName:"${member.lastName}",
  country:"${member.country}",
  email:"${member.email}",
  title:"${member.title}",
  gender:"${member.gender}",
  university:"${member.university}",
  link:"${member.link}",
  biography:"${member.biography}",
  role:"${member.role}",
  hasSubmitted:${member.hasSubmitted},
  isInternationalCommittee:${member.isInternationalCommittee},
  isLocalCommittee:${member.isLocalCommittee},
  isScientificCommittee:${member.isScientificCommittee},
  isInvitedSpeaker:${member.isInvitedSpeaker},
  isFullRegistered:${member.isFullRegistered},
  isReviewer:${member.isReviewer}){
    ${`
    _id
    conference
        firstName
        lastName
        country
        email
        title
        gender
        university
        link
        biography
        role
        hasSubmitted
        isInternationalCommittee
        isLocalCommittee
        isScientificCommittee
        isFullRegistered
        isReviewer
        isAdmin
        hasEditConferences
        hasEditContent
        hasEditMembers
        hasEditArticles
        hasEditAdmins
    `}
  }}`;
};

export const updateChairman = (member: IMember) => {
  return gql`mutation {updateChairman(_id:"${member._id}",
  conference:"${member.conference}"){
    ${`
    _id
    conference
        isChairman
    `}
  }}`;
};

export const updateCoChairman = (member: IMember) => {
  return gql`mutation {updateCoChairman(_id:"${member._id}",
  conference:"${member.conference}"){
    ${`
    _id
    conference
        isCoChairman
    `}
  }}`;
};

export const updateHonoraryChairman = (member: IMember) => {
  return gql`mutation {updateHonoraryChairman(_id:"${member._id}",
  conference:"${member.conference}"){
    ${`
    _id
    conference
    isHonoraryChairman
    `}
  }}`;
};

export const updateScientificCommitteeChairman = (member: IMember) => {
  return gql`mutation {updateScientificCommitteeChairman(_id:"${member._id}",
  conference:"${member.conference}"){
    ${`
    _id
    conference
    isScientificCommitteeChairman
    `}
  }}`;
};

export const updateMainOrganizer = (member: IMember) => {
  return gql`mutation {updateMainOrganizer(_id:"${member._id}",
  conference:"${member.conference}"){
    ${`
    _id
    conference
    isMainOrganizer
    `}
  }}`;
};

export const updateAdmin = (member: IMember) => {
  return gql`mutation {updateAdmin(_id:"${member._id}",
  conference:"${member.conference}",
  isAdmin:${member.isAdmin},
  hasEditConferences:${member.hasEditConferences},
  hasEditContent:${member.hasEditContent},
  hasEditMembers:${member.hasEditMembers},
  hasEditArticles:${member.hasEditArticles},
  hasEditAdmins:${member.hasEditAdmins}){
    ${`
    _id
    conference
        firstName
        lastName
        country
        email
        title
        university
        link
        role
        isInternationalCommittee
        isLocalCommittee
        isScientificCommittee
        isFullRegistered
        isReviewer
        isAdmin
        hasEditConferences
        hasEditContent
        hasEditMembers
        hasEditArticles
        hasEditAdmins
    `}
  }}`;
};
export const updateProfile = (member: IMember) => {
  return gql`mutation {updateProfile(
  conference:"${member.conference}",
  firstName:"${member.firstName}",
lastName:"${member.lastName}",
country:"${member.country}",
title:"${member.title}",
gender:"${member.gender}",
university:"${member.university}",
link:"${member.link}",
biography:"${member.biography}"
  ){
    ${`
    _id
    conference
        firstName
        lastName
        country
        email
        title
        gender
        university
        link
        biography
        role
        isInternationalCommittee
        isLocalCommittee
        isScientificCommittee
        isFullRegistered
        isReviewer
        isAdmin
        hasEditConferences
        hasEditContent
        hasEditMembers
        hasEditArticles
        hasEditAdmins
    `}
  }}`;
};

export const addMember = (member: IMember) => {
  return gql`
    mutation {
      addMember(
        conference:"${member.conference}",
        firstName:"${member.firstName}",
        lastName:"${member.lastName}",
        country:"${member.country}",
        email:"${member.email}",
        title:"${member.title}",
        university:"${member.university}")
{

      _id
    conference
    firstName
    lastName
    title
    university
    country
    email

  
        }
    }
`;
};

export const deleteMember = (member: IMember) => {
  return gql`
    mutation {
      deleteMember(
        conference:"${member.conference}",
        _id:"${member._id}")
{
      _id
    conference
    firstName
    lastName
    title
    university
    country
    email
        }
    }
`;
};
